import axios from 'axios'

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getPayments(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/payments",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        updatePayment(obj, { id, request }) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/payments/' + id,
                    data: request,
                    method: 'PUT'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        deletePayment(obj, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/payments/' + id,
                    method: 'DELETE'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        createPayment(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/payments",
                    data: obj,
                    method: "POST"
                }).then(response => {
                    if (response.data.status) {
                        resolve(response);
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getPaymentStudents(obj, { id, params }) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/payments/" + id + "/students",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getPaymentStudentParents(obj, { id, idStudent, params }) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/payments/" + id + "/students/" + idStudent,
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getPaymentsKeys() {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/payments/payments-keys",
                    method: "GET",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        savePaymentsKeys(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/payments/payments-keys",
                    data: obj,
                    method: "PUT",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },        
    }
}